import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import usePermissions from '../hooks/usePermissions';

const RoleProtectedRoute = ({ allowedRoles = [], children }) => {
  const { loading, user } = useAuth();
  const { role } = usePermissions();

  if (loading) {
    return (
      <div className="min-h-screen bg-legal-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-court-600" />
      </div>
    );
  }

  if (user && user.is_active === false) {
    return <Navigate to="/login?deactivated=1" replace />;
  }

  const normalized = role.toLowerCase().replace(/\s+/g, '_');
  const allowed = allowedRoles.map((r) => r.toLowerCase().replace(/\s+/g, '_'));

  if (!allowed.includes(normalized)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RoleProtectedRoute;
